// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutPage_container__3AXto","menu":"LayoutPage_menu__148fw"};